import gql from 'graphql-tag';

const QUERY_ESIM_HISTORIES = gql`
  query esimHistories($filter: ListEsimHistoriesFilterInput, $limit: Int) {
    esimHistories(filter: $filter, limit: $limit) {
      isSuccess
      message
      audits {
        id
        createdAt
        column
        actionBy {
          id
          firstName
          lastName
        }
        table
        valueAfter
        valueBefore
        licenseAfter {
          id
          isAllowedDual
          licenseType
          name
          productId
          storage
        }
        licenseBefore {
          id
          isAllowedDual
          licenseType
          name
          productId
          storage
        }
      }
    }
  }
`;

export default QUERY_ESIM_HISTORIES;
